import React from "react";
import Image from "react-image";
import { connect } from "react-redux";

export const BackgroundImageComponent = ({ theme, type }) => {
  const background = theme[`background_image_${type}`];
  return background ? (
    <Image className="o-background" src={background} />
  ) : null;
};

const mapStateToProps = state => ({
  theme: { ...state.theme }
});

export const BackgroundImageComponentConnected = connect(mapStateToProps)(
  BackgroundImageComponent
);
